import React from 'react';
import PropTypes from 'prop-types';
import enhance from './CompanyDashboard.enhancer';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import DealsOverviewTable from '../shared/DealsOverviewTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ProductPhotoUpload from '../../company/campaign/components/ProductPhotoUpload';
import ItemsCarousel from 'react-items-carousel';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import VideocamIcon from '@material-ui/icons/Videocam';
import PaymentIcon from '@material-ui/icons/Payment';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
import SendCampaignMatchPopup from '../../shared/components/SendCampaignMatchPopup';
import Paper from '@material-ui/core/Paper';
import LinkText from '../../shared/components/LinkText';
import DeleteIcon from '@material-ui/icons/Delete';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { dealStatuses } from '../../../constants';
import '../../../index.css';
import Divider from '@material-ui/core/Divider';
import axios from 'axios';
import YouTube from 'react-youtube';

class CompanyDashboard extends React.Component {
  constructor() {
    super();

    this.initialState = {
      productName: '',
      productPrice: '',
      productNotes: '',
      productPhotoUrl: '',
      currentActiveProduct: 0,
      youtubeUploadsLoaded: false,
      influencersLoaded: false,
      currentActiveInfluencer: 0,
      currentActiveYoutubeVideo: 0,
      numberOfVideoCards: this.currentWidthVideos(),
      numberOfInfluencerCards: this.currentWidthInfluencers(),
      computedActiveCampaigns: [],
      player: []
    };

    this.state = {
      ...this.initialState
    };
    this._onReady = this._onReady.bind(this);
  }

  componentDidMount() {
    // load recent youtube videos
    if (
      (!this.props.youtubeUploads || !this.props.youtubeUploads.length) &&
      !this.state.youtubeUploadsLoaded
    ) {
      this.setState({
        youtubeUploadsLoaded: true
      });
      this.props.loadRelevantYoutubeUploads(this.props.auth.uid);
    }
    // load relevant influencers
    if (
      (!this.props.relevantInfluencers ||
        !this.props.relevantInfluencers.length) &&
      !this.state.influencersLoaded
    ) {
      this.setState({
        influencersLoaded: true
      });
      this.props.loadRelevantInfluencersHandler();
    }

    window.addEventListener(
      'resize',
      () => {
        const numberOfVideoCards = this.currentWidthVideos();
        if (this.state.numberOfVideoCards !== numberOfVideoCards) {
          this.setState({
            numberOfVideoCards
          });
        }
      },
      false
    );
    window.addEventListener(
      'resize',
      () => {
        const numberOfInfluencerCards = this.currentWidthInfluencers();
        if (this.state.numberOfInfluencerCards !== numberOfInfluencerCards) {
          this.setState({
            numberOfInfluencerCards
          });
        }
      },
      false
    );

    this.computeActiveCampaignDetails();
    // try {
    //   axios
    //     .get(`${process.env.REACT_APP_FIREBASE_URL}/testyoutubeRefresh`)
    //     .then(res => {
    //       console.log(res.status);
    //     });
    // } catch (e) {
    //   console.log("catch")
    // }
  }

  computeActiveCampaignDetails() {
    return this.props.campaignList.map(campaign => {
      //compute dollars spent and total views
      const campaignDeals = this.props.dealList.filter(
        deal => deal.campaignId === campaign.id
      );

      const totalPayout = campaignDeals.reduce((totalPayout, deal) => {
        if (
          deal.status === dealStatuses.COMPLETE ||
          deal.status === dealStatuses.ACTIVE ||
          deal.status === dealStatuses.CONTENT_COMPLETE ||
          deal.status === dealStatuses.DISPUTE_OPENED
        ) {
          return (
            parseFloat(deal.currentProposal.payout) + parseFloat(totalPayout)
          );
        } else {
          return totalPayout;
        }
      }, 0);

      const totalViews = campaign.statistics
        ? campaign.statistics.totalViews
        : 0;

      return {
        ...campaign,
        totalPayout,
        totalViews,
        proposals: campaignDeals.filter(
          deal => deal.status === dealStatuses.PROPOSAL_SENT
        ).length,
        pendingEscrow: campaignDeals.filter(
          deal => deal.status === dealStatuses.DEAL_ACCEPTED
        ).length,
        activeDeals: campaignDeals.filter(
          deal => deal.status === dealStatuses.ACTIVE
        ).length,
        contentReviewDeals: campaignDeals.filter(
          deal => deal.status === dealStatuses.CONTENT_COMPLETE
        ).length
      };
    });
  }

  currentWidthVideos() {
    let numberOfCards;

    if (window.innerWidth < 600) numberOfCards = 1;
    else if (window.innerWidth < 1100) numberOfCards = 2;
    else if (window.innerWidth < 1500) numberOfCards = 3;
    else numberOfCards = 4;

    return numberOfCards;
  }

  currentWidthInfluencers() {
    let numberOfCards;

    if (window.innerWidth < 600) numberOfCards = 1;
    else if (window.innerWidth < 800) numberOfCards = 2;
    else if (window.innerWidth < 1280) numberOfCards = 3;
    else numberOfCards = 4;

    return numberOfCards;
  }

  getInterests(influencer) {
    if (!influencer.interests || !influencer.interests.length) {
      return [];
    }

    return influencer.interests.slice(0, 3);
  }

  changeHandler(e) {
    this.setState({
      ...this.state,
      [e.target.name]: e.target.value
    });
  }

  handleProductPhotoUploadSuccess = productPhotoUrl => {
    this.setState({
      ...this.state,
      productPhotoUrl
    });
  };

  addNewProduct() {
    const newProduct = {
      productName: this.state.productName,
      productPrice: this.state.productPrice,
      productNotes: this.state.productNotes,
      productPhotoUrl: this.state.productPhotoUrl
    };

    this.props.addProductHandler(this.props.auth.uid, newProduct);

    this.setState({
      productName: '',
      productPrice: '',
      productNotes: '',
      productPhotoUrl: ''
    });
  }

  setActiveInfluencer = value => {
    this.setState({
      ...this.state,
      currentActiveInfluencer: value
    });
  };

  setActiveProduct = value => {
    this.setState({
      ...this.state,
      currentActiveProduct: value
    });
  };

  setActiveYoutubeVideo = value => {
    this.setState({
      ...this.state,
      currentActiveYoutubeVideo: value
    });
  };

  openSendMatchPopup = (influencerId, event) => {
    this.setState({
      ...this.state,
      campaignMatchPopupOpen: true,
      campaignMatchPopupTarget: event.target,
      influencerMatchSelection: influencerId
    });
  };

  closeSendMatchPopup() {
    this.setState({
      ...this.state,
      campaignMatchPopupOpen: false,
      campaignMatchPopupTarget: null,
      campaignSelection: null,
      influencerMatchSelection: null
    });
  }

  campaignChangeHandler(e) {
    this.setState({
      ...this.state,
      campaignSelection: e.target.value
    });
  }

  sendMatchRequest() {
    this.props.CompanyMatchRequestHandler(
      this.state.influencerMatchSelection,
      this.props.auth.uid,
      this.state.campaignSelection
    );

    this.setState({
      ...this.state,
      campaignMatchPopupOpen: false,
      campaignMatchPopupTarget: null,
      campaignSelection: null,
      influencerMatchSelection: null
    });
  }

  navigateToProfile(userId) {
    this.props.history.push(`user/${userId}/profile`);
  }

  navigateToCreateCampaign() {
    this.props.history.push(`campaign/new`);
  }

  navigateToProposals = campaignId => {
    this.props.history.push(`campaigns/${campaignId}/proposals`);
  };

  navigateToPendingEscrow = campaignId => {
    this.props.history.push(`campaigns/${campaignId}/pendingEscrow`);
  };

  navigateToActiveDeals = campaignId => {
    this.props.history.push(`campaigns/${campaignId}/active`);
  };

  navigateToContentCompleteDeals = campaignId => {
    this.props.history.push(`campaigns/${campaignId}/contentComplete`);
  };

  navigateToCampaignAnalytics = campaignId => {
    this.props.history.push(`campaigns/${campaignId}/analytics`);
  };

  removeProduct(product) {
    this.props.removeProductHandler(this.props.auth.uid, product);
  }

  _onReady(event) {
    const player = this.state.player;
    player.push(event.target);
    this.setState({
      player: player
    });
  }


  pauseAllPlayCurrent(event){
    const players = this.state.player
    const currentId = event.target.h.id
    console.log("starting to pause videos")
    if(players && players.length > 0)
      players.forEach(player => {
        const id = player.h.id
        const isPlaying = player.getPlayerState() === 1
        const isNotCurrentVideo = currentId !== id
        console.log(id, currentId, isNotCurrentVideo, isPlaying)
        console.log(id, player)
        if(isNotCurrentVideo && isPlaying)
          player.pauseVideo()
      })

    // // access to player in all event handlers via event.target
    // event.target.playVideo();
  }

  render() {
    const {
      classes,
      auth,
      profile,
      youtubeUploads,
      dealList,
      activeDealsCount,
      pendingContentApprovalCount,
      pendingMatchesCount,
      pendingEscrowCount,
      campaignList,
      relevantInfluencers
    } = this.props;
    const {
      productName,
      productPrice,
      productNotes,
      productPhotoUrl,
      currentActiveProduct,
      currentActiveInfluencer,
      currentActiveYoutubeVideo,
      numberOfVideoCards,
      numberOfInfluencerCards,
      campaignMatchPopupOpen,
      campaignMatchPopupTarget,
      campaignSelection,
      computedActiveCampaigns
    } = this.state;

    const youtubeOps = {}

    return (
      <React.Fragment>
        <main className={classes.dashboardContainer}>
          <Typography variant="h3" id="tableTitle" className={classes.title}>
            Company Dashboard
          </Typography>
          <Grid container direction="column" spacing={8}>
            <div className={classes.newCampaignButtonContainer}>
              <Button
                className={classes.newCampaignButton}
                onClick={() => this.navigateToCreateCampaign()}
              >
                Create New Campaign
              </Button>
            </div>
            <Grid container xs={12}>
              {this.props.campaignList &&
                this.props.campaignList.length > 0 &&
                this.props.dealList && (
                  <Paper className={classes.campaignItemContainer}>
                    <Grid container item direction="column" xs={12}>
                      <div
                        item
                        container
                        xs={12}
                        className={classes.activeCampaignsContainer}
                      >
                        <Grid className={classes.activeCampaignsTitle}>
                          <Typography variant="h5">Active Campaigns</Typography>
                        </Grid>
                      </div>
                      {this.computeActiveCampaignDetails().map(
                        (computedCampaign, index, arr) => (
                          <Grid
                            container
                            xs={12}
                            direction="column"
                            className={classes.activeCampaignContainer}
                          >
                            <Grid item className={classes.campaignItemTitle}>
                              <Typography variant="h6">
                                {computedCampaign.name}
                              </Typography>
                            </Grid>
                            <Grid
                              container
                              item
                              direction="row"
                              item
                              xs={12}
                              className={classes.campaignItem}
                            >
                              <div
                                className={classes.campaignItemLeftContainer}
                              >
                                <Grid container direction="column" xs={12}>
                                  <Grid item></Grid>
                                  <Grid item>
                                    <Typography align="center" display="inline">
                                      ${`${computedCampaign.totalPayout} `}
                                    </Typography>
                                    <Typography align="center" display="inline">
                                      Paid Out
                                    </Typography>
                                  </Grid>
                                  <Grid item className={classes.totalViews}>
                                    <Typography align="center" display="inline">
                                      {`${computedCampaign.totalViews} `}
                                    </Typography>
                                    <Typography align="center" display="inline">
                                      Total Views
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                              <div
                                className={classes.campaignItemRightContainer}
                              >
                                <Grid item container direction="row">
                                  <Paper
                                    item
                                    className={classes.campaignStatContainer}
                                    onClick={() =>
                                      this.navigateToProposals(
                                        computedCampaign.id
                                      )
                                    }
                                  >
                                    <div>
                                      <Typography
                                        variant="h6"
                                        align="center"
                                        justify="center"
                                        className={classes.campaignStat}
                                      >
                                        {computedCampaign.proposals}
                                      </Typography>
                                      <Typography
                                        align="center"
                                        justify="center"
                                      >
                                        Proposals
                                      </Typography>
                                    </div>
                                  </Paper>
                                  <Paper
                                    item
                                    className={classes.campaignStatContainer}
                                    onClick={() =>
                                      this.navigateToPendingEscrow(
                                        computedCampaign.id
                                      )
                                    }
                                  >
                                    <div>
                                      <Typography
                                        variant="h6"
                                        align="center"
                                        justify="center"
                                        className={classes.campaignStat}
                                      >
                                        {computedCampaign.pendingEscrow}
                                      </Typography>
                                      <Typography
                                        align="center"
                                        justify="center"
                                      >
                                        Pending Escrow
                                      </Typography>
                                    </div>
                                  </Paper>
                                  <Paper
                                    item
                                    className={classes.campaignStatContainer}
                                    onClick={() =>
                                      this.navigateToActiveDeals(
                                        computedCampaign.id
                                      )
                                    }
                                  >
                                    <div>
                                      <Typography
                                        variant="h6"
                                        align="center"
                                        justify="center"
                                        className={classes.campaignStat}
                                      >
                                        {computedCampaign.activeDeals}
                                      </Typography>
                                      <Typography
                                        align="center"
                                        justify="center"
                                      >
                                        Active Deals
                                      </Typography>
                                    </div>
                                  </Paper>
                                  <Paper
                                    item
                                    className={classes.campaignStatContainer}
                                    onClick={() =>
                                      this.navigateToContentCompleteDeals(
                                        computedCampaign.id
                                      )
                                    }
                                  >
                                    <div>
                                      <Typography
                                        variant="h6"
                                        align="center"
                                        justify="center"
                                        className={classes.campaignStat}
                                      >
                                        {computedCampaign.contentReviewDeals}
                                      </Typography>
                                      <Typography
                                        align="center"
                                        justify="center"
                                      >
                                        Content Review
                                      </Typography>
                                    </div>
                                  </Paper>
                                </Grid>
                              </div>
                              <div className={classes.campaignItemButtons}>
                                <div>
                                  <Button
                                    className={classes.campaignItemButtonUpper}
                                    onClick={() =>
                                      this.navigateToProposals(
                                        computedCampaign.id
                                      )
                                    }
                                  >
                                    Campaign Details
                                  </Button>
                                </div>
                                <div>
                                  <Button
                                    className={classes.campaignItemButton}
                                    onClick={() =>
                                      this.navigateToCampaignAnalytics(
                                        computedCampaign.id
                                      )
                                    }
                                  >
                                    Campaign Analytics
                                  </Button>
                                </div>
                              </div>
                            </Grid>
                            {index < arr.length - 1 && <Divider />}
                          </Grid>
                        )
                      )}
                    </Grid>
                  </Paper>
                )}
            </Grid>
            <Grid item xs={12}>
              <DealsOverviewTable dealList={dealList} forCompany={true} />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.subTitle} variant="h5">
                Latest Activity
              </Typography>
              <div style={{ width: '95%' }}>
                <ItemsCarousel
                  gutter={12}
                  activePosition={'center'}
                  chevronWidth={40}
                  numberOfCards={numberOfVideoCards}
                  outsideChevron={true}
                  showSlither={false}
                  firstAndLastGutter={false}
                  activeItemIndex={currentActiveYoutubeVideo}
                  requestToChangeActive={this.setActiveYoutubeVideo.bind(this)}
                  rightChevron={<ChevronRightIcon />}
                  leftChevron={<ChevronLeftIcon />}
                >
                  {youtubeUploads &&
                    youtubeUploads.map((upload,i) => (
                      <div
                        key={upload.videoId}
                        className={classes.youtubeVideoUpload}
                      >
                        {/*<iframe*/}
                        {/*  className={classes.iframeContainer}*/}
                        {/*  src={`https://www.youtube.com/embed/${upload.videoId}?enablejsapi=1`}*/}
                        {/*  frameborder="0"*/}
                        {/*  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"*/}
                        {/*  allowfullscreen*/}
                        {/*/>*/}
                        <YouTube
                            id={'youtube-video-'+ upload.videoId + '-' + i}
                           className={classes.iframeContainer}
                           videoId={upload.videoId}
                           opts={youtubeOps}
                            onReady={this._onReady}
                            onPlay={this.pauseAllPlayCurrent.bind(this)}
                        />
                      </div>
                    ))}
                </ItemsCarousel>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Typography
                className={classes.subTitle}
                variant="h5"
                id="tableTitle"
              >
                Suggested Influencers
              </Typography>
              <Grid container direction="row">
                {relevantInfluencers && relevantInfluencers.length > 0 && (
                  <div style={{ width: '95%' }}>
                    <ItemsCarousel
                      gutter={12}
                      activePosition={'center'}
                      chevronWidth={40}
                      numberOfCards={numberOfInfluencerCards}
                      outsideChevron={true}
                      showSlither={false}
                      firstAndLastGutter={false}
                      activeItemIndex={currentActiveInfluencer}
                      requestToChangeActive={this.setActiveInfluencer.bind(
                        this
                      )}
                      rightChevron={<ChevronRightIcon />}
                      leftChevron={<ChevronLeftIcon />}
                      className={classes.carousel}
                    >
                      {relevantInfluencers.map((influencer, i) => (
                        <Paper className={classes.carousel}>
                          <Card key={i} className={classes.suggestCard}>
                            <CardHeader
                              title={
                                <Grid
                                  container
                                  justify="space-between"
                                  spacing={1}
                                  className={classes.interest}
                                >
                                  {this.getInterests(influencer).map(
                                    interest => {
                                      return (
                                        <Grid item>
                                          <Typography>{interest}</Typography>
                                        </Grid>
                                      );
                                    }
                                  )}
                                </Grid>
                              }
                              className={classes.suggestCardHeader}
                            />
                            <CardContent className={classes.suggestCardContent}>
                              <Grid container direction="column">
                                <Grid item xs={12} align="center">
                                  <div className={classes.profilePicture}>
                                    <img src={influencer.profilePictureUrl} />
                                  </div>
                                </Grid>
                                <Grid item xs={12} align="center">
                                  <LinkText
                                    variant="h5"
                                    onClick={() =>
                                      this.navigateToProfile(influencer.id)
                                    }
                                  >
                                    {influencer.displayName}
                                  </LinkText>
                                </Grid>
                                <Grid item xs={12} align="center">
                                  <Fab
                                    size="small"
                                    color="secondary"
                                    aria-label="youtube"
                                  >
                                    <FontAwesomeIcon
                                      className={classes.youtubeIcon}
                                      icon={faYoutube}
                                    />
                                  </Fab>
                                  <Typography>
                                    {influencer.youtube
                                      ? influencer.youtube.subscribers.toLocaleString()
                                      : 0}
                                  </Typography>
                                  {/* </Grid>
                                  <Typography>

                                  </Typography>
                                <Grid item> */}
                                </Grid>
                              </Grid>
                            </CardContent>
                            <CardActions className={classes.suggestCardActions}>
                              <Grid
                                container
                                className={classes.influencerListBottom}
                                align="center"
                              >
                                <Grid
                                  item
                                  xs={12}
                                  onClick={event =>
                                    this.openSendMatchPopup(
                                      influencer.id,
                                      event
                                    )
                                  }
                                >
                                  <Typography
                                    className={classes.requestText}
                                    align="center"
                                  >
                                    Invite to Campaign
                                  </Typography>
                                </Grid>
                              </Grid>
                            </CardActions>
                          </Card>
                        </Paper>
                      ))}
                    </ItemsCarousel>
                  </div>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.subTitle} variant="h5">
                Products
              </Typography>
              {profile.products && profile.products.length > 0 && (
                <ItemsCarousel
                  gutter={12}
                  activePosition={'center'}
                  chevronWidth={40}
                  numberOfCards={4}
                  outsideChevron={true}
                  showSlither={false}
                  firstAndLastGutter={false}
                  activeItemIndex={currentActiveProduct}
                  requestToChangeActive={this.setActiveProduct.bind(this)}
                  rightChevron={<ChevronRightIcon />}
                  leftChevron={<ChevronLeftIcon />}
                >
                  {profile.products.map((product, i) => (
                    <Grid
                      container
                      direction="column"
                      className={classes.productCarouselItem}
                      align="center"
                      justify="top"
                      key={i}
                    >
                      <DeleteIcon
                        className={classes.removeButton}
                        onClick={() => this.removeProduct(product)}
                      />
                      {product.productPhotoUrl && (
                        <img
                          src={product.productPhotoUrl}
                          className={classes.carouselBottomImage}
                        />
                      )}
                      {!product.productPhotoUrl && (
                        <img
                          src="/images/no-product-image.png"
                          className={classes.carouselBottomImage}
                        />
                      )}
                      <Grid item xs={12} className={classes.carouselBottom}>
                        <Typography align="center">
                          {product.productName}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </ItemsCarousel>
              )}
            </Grid>
            <Grid item xs={12}>
              <Grid container direction="row">
                <Grid
                  item
                  lg={4}
                  sm={6}
                  className={classes.newProductContainer}
                >
                  <Card>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item sm={6} xs={12}>
                          <Typography gutterBottom align="left" display="block">
                            Product Name
                          </Typography>
                          <TextField
                            id="productName"
                            name="productName"
                            variant="outlined"
                            value={productName}
                            fullWidth
                            onChange={this.changeHandler.bind(this)}
                          />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                          <Typography gutterBottom align="left" display="block">
                            Product Price
                          </Typography>
                          <TextField
                            id="productPrice"
                            name="productPrice"
                            variant="outlined"
                            type="number"
                            value={productPrice}
                            fullWidth
                            onChange={this.changeHandler.bind(this)}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography gutterBottom align="left" display="block">
                            Product Photo
                          </Typography>
                          <ProductPhotoUpload
                            productPhotoUrl={productPhotoUrl}
                            uploadHandler={this.handleProductPhotoUploadSuccess.bind(
                              this
                            )}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Typography gutterBottom align="left" display="block">
                            Notes
                          </Typography>
                          <TextField
                            id="productNotes"
                            name="productNotes"
                            variant="outlined"
                            fullWidth
                            multiline
                            value={productNotes}
                            onChange={this.changeHandler.bind(this)}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            variant="contained"
                            color="primary"
                            align="right"
                            className={classes.add}
                            onClick={this.addNewProduct.bind(this)}
                          >
                            Add
                          </Button>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </main>
        <SendCampaignMatchPopup
          open={campaignMatchPopupOpen}
          campaignMatchPopupTarget={campaignMatchPopupTarget}
          onClose={this.closeSendMatchPopup.bind(this)}
          campaigns={campaignList}
          campaignChangeHandler={this.campaignChangeHandler.bind(this)}
          campaignSelection={campaignSelection}
          sendMatchRequest={this.sendMatchRequest.bind(this)}
        />
      </React.Fragment>
    );
  }
}

CompanyDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object,
  profile: PropTypes.object,
  router: PropTypes.object
};

export default enhance(CompanyDashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/company/CompanyDashboard.js